import { render, staticRenderFns } from "./ProductFilterCategory.vue?vue&type=template&id=4b9d3ac6&scoped=true&"
import script from "./ProductFilterCategory.vue?vue&type=script&lang=js&"
export * from "./ProductFilterCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilterCategory.vue?vue&type=style&index=0&id=4b9d3ac6&lang=scss&scoped=true&"
import style1 from "./ProductFilterCategory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d3ac6",
  null
  
)

export default component.exports